module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "film-festival"
  }, [_c('div', {
    staticClass: "default__bg"
  }), _vm._v(" "), _c('sk-container', [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : _c('div', {
    staticClass: "movie-detail"
  }, [_c('sk-panel', [_c('sk-layout', {
    class: (!_vm.$breakpoints.xs ? 'gutter-40' : ''),
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm5": "",
      "md3": ""
    }
  }, [_c('div', {
    staticClass: "movie-detail-poster"
  }, [_c('div', {
    staticClass: "movie-detail__poster-img"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.filmFestival.images.poster.url,
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm7": "",
      "md7": ""
    }
  }, [(_vm.$breakpoints.xs) ? _c('sk-spacer', {
    attrs: {
      "height": "20"
    }
  }) : _vm._e(), _vm._v(" "), _c('h3', {
    staticClass: "movie-detail__releasing"
  }, [_vm._v("\n                            " + _vm._s(_vm.filmFestival.StartDate.format('dddd Do MMMM YYYY')) + "\n                        ")]), _vm._v(" "), _c('h1', {
    staticClass: "movie-detail__title"
  }, [_vm._v("\n                            " + _vm._s(_vm.filmFestival.Name) + " \n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "hidden-xs"
  }, [_c('p', {
    staticClass: "movie-detail__summary"
  }, [(_vm.filmFestival.Description) ? [_vm._v("\n                                    " + _vm._s(_vm.filmFestival.Description) + "\n                                ")] : _vm._e()], 2)])], 1)], 1), _vm._v(" "), _c('sk-layout', {
    staticClass: "visible-xs"
  }, [_c('sk-spacer', {
    attrs: {
      "height": "20"
    }
  }), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "movie-detail__summary"
  }, [_vm._v("\n                            " + _vm._s(_vm.filmFestival.Description) + "\n                        ")])])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.filmFestival.Movies.length > 0) ? [_c('h3', {
    staticClass: "featured-heading"
  }, [_vm._v("Features")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('sk-layout', {
    staticClass: "movie-listing__list",
    class: (_vm.activeMovie ? 'movie-listing__list--active' : ''),
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.filmFestival.Movies), function(movie) {
    return (_vm.filmFestival.Movies) ? _c('sk-flex', {
      key: movie.id,
      attrs: {
        "xs6": "",
        "sm4": "",
        "md2": "",
        "lg2": ""
      }
    }, [(_vm.filmFestival.Movies) ? _c('sk-movie-thumbnail', {
      style: ({
        marginBottom: _vm.activeMovie == movie ? _vm.bottomOffset : ''
      }),
      attrs: {
        "now-showing": "",
        "content": movie
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.$router.push(("/details/" + (movie.id) + "/film-festival/" + (_vm.$route.params.id)))
        }
      }
    }) : _vm._e()], 1) : _vm._e()
  }))] : _vm._e(), _vm._v(" "), _c('sk-signin')], 2)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54a3879e","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/film-festivals/film-festivals.vue
// module id = 690
// module chunks = 0